import { COLORS } from '@/config/colors';

/** 0xRRGGBB → '#rrggbb' */
export function css(color: number): string {
  return '#' + color.toString(16).padStart(6, '0');
}

/** Darken/lighten a color by factor f (f<1 darker, f>1 lighter) */
export function shade(color: number, f: number): number {
  const r = Math.min(255, Math.round(((color >> 16) & 0xff) * f));
  const g = Math.min(255, Math.round(((color >> 8) & 0xff) * f));
  const b = Math.min(255, Math.round((color & 0xff) * f));
  return (r << 16) | (g << 8) | b;
}

/** Apply the standard thick outline style and stroke */
export function outline(ctx: CanvasRenderingContext2D, width: number): void {
  ctx.strokeStyle = css(COLORS.outline);
  ctx.lineWidth = width;
  ctx.lineJoin = 'round';
  ctx.lineCap = 'round';
  ctx.stroke();
}

/** Fill + outline in one go */
export function fillOutlined(
  ctx: CanvasRenderingContext2D,
  fill: number,
  outlineWidth: number,
): void {
  ctx.fillStyle = css(fill);
  ctx.fill();
  outline(ctx, outlineWidth);
}

/** Simple circle path */
export function circle(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  r: number,
): void {
  ctx.beginPath();
  ctx.arc(x, y, r, 0, Math.PI * 2);
}

/** Closed polygon path with rounded corners */
export function roundedPoly(
  ctx: CanvasRenderingContext2D,
  pts: ReadonlyArray<readonly [number, number]>,
  radius: number,
): void {
  ctx.beginPath();
  const n = pts.length;
  for (let i = 0; i < n; i++) {
    const p0 = pts[i]!;
    const p1 = pts[(i + 1) % n]!;
    const p2 = pts[(i + 2) % n]!;
    const mid1: [number, number] = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
    const mid2: [number, number] = [(p1[0] + p2[0]) / 2, (p1[1] + p2[1]) / 2];
    if (i === 0) ctx.moveTo(mid1[0], mid1[1]);
    ctx.arcTo(p1[0], p1[1], mid2[0], mid2[1], radius);
  }
  ctx.closePath();
}
